const _ = {
  actions: {
    GetCaseCateList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/case/category/list',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetCaseData({ commit, state }, params) {
      return mm
        .http({
          url: '/api/datasource/case',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetCaseList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/case/list',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
  }
}

export default _
